import {
    ADDITIONAL_FEE_USER_RESPONSE_START,
    ADDITIONAL_FEE_USER_RESPONSE_SUCCESS,
    ADDITIONAL_FEE_USER_RESPONSE_ERROR
} from '../../constants';
import { additionalFeeUserResponse as mutation } from '../../lib/graphql/booking';
import showToaster from '../../helpers/toastrMessgaes/showToaster';
import { closeHeaderModal } from '../siteadmin/modalActions';
import { getBooking } from './getBooking';
import { setLoaderStart, setLoaderComplete } from '../loader/loader';

export function additionalFeeUserResponseAction({ bookingId, status }) {

    return async (dispatch, getState, { client }) => {
        try {
            const loader = status === 'approved' ? 'approveLoader' : 'rejectLoader';
            dispatch(setLoaderStart(loader));

            dispatch({
                type: ADDITIONAL_FEE_USER_RESPONSE_START,
            });

            const { data } = await client.mutate({
                mutation,
                variables: {
                    bookingId,
                    status
                },
            });

            dispatch(setLoaderComplete(loader));

            if (data?.additionalFeeUserResponse?.status === 200) {
                dispatch({
                    type: ADDITIONAL_FEE_USER_RESPONSE_SUCCESS,
                });
                await dispatch(getBooking(bookingId));
                dispatch(closeHeaderModal('additionalRequest'));
            } else {
                dispatch({
                    type: ADDITIONAL_FEE_USER_RESPONSE_ERROR,
                    payload: {
                        error: data?.additionalFeeUserResponse?.errorMessage,
                    },
                });
                await showToaster({ messageId: 'errorMessage', toasterType: 'error', requestContent: data?.additionalFeeUserResponse?.errorMessage })
            }
        } catch (error) {
            dispatch({
                type: ADDITIONAL_FEE_USER_RESPONSE_ERROR,
                payload: {
                    error,
                },
            });
            return false;
        }
        return true;
    };
}